import { storage } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { DeadpoolUser } from '~types/index'
import { CART_MIGRABLE, GUEST_CART } from '../constants'

const db = storage('local')

export interface UpdateIsMigrableCartProps {
  shouldInitialize: boolean
  customer: DeadpoolUser | null
  products: object
  type: string
  cartId: string
}
const updateIsMigrableCart = ({
  shouldInitialize,
  customer,
  products,
  type,
  cartId,
}: UpdateIsMigrableCartProps) => {
  if (shouldInitialize && !customer) {
    const migrable =
      type === GUEST_CART && cartId && Object.keys(products).length > 0
    db.setItem(CART_MIGRABLE, migrable)
  }
}

export default updateIsMigrableCart
